import { createAggregatedClient } from "@smithy/smithy-client";
import { BatchDetectDominantLanguageCommand, } from "./commands/BatchDetectDominantLanguageCommand";
import { BatchDetectEntitiesCommand, } from "./commands/BatchDetectEntitiesCommand";
import { BatchDetectKeyPhrasesCommand, } from "./commands/BatchDetectKeyPhrasesCommand";
import { BatchDetectSentimentCommand, } from "./commands/BatchDetectSentimentCommand";
import { BatchDetectSyntaxCommand, } from "./commands/BatchDetectSyntaxCommand";
import { BatchDetectTargetedSentimentCommand, } from "./commands/BatchDetectTargetedSentimentCommand";
import { ClassifyDocumentCommand, } from "./commands/ClassifyDocumentCommand";
import { ContainsPiiEntitiesCommand, } from "./commands/ContainsPiiEntitiesCommand";
import { CreateDatasetCommand, } from "./commands/CreateDatasetCommand";
import { CreateDocumentClassifierCommand, } from "./commands/CreateDocumentClassifierCommand";
import { CreateEndpointCommand, } from "./commands/CreateEndpointCommand";
import { CreateEntityRecognizerCommand, } from "./commands/CreateEntityRecognizerCommand";
import { CreateFlywheelCommand, } from "./commands/CreateFlywheelCommand";
import { DeleteDocumentClassifierCommand, } from "./commands/DeleteDocumentClassifierCommand";
import { DeleteEndpointCommand, } from "./commands/DeleteEndpointCommand";
import { DeleteEntityRecognizerCommand, } from "./commands/DeleteEntityRecognizerCommand";
import { DeleteFlywheelCommand, } from "./commands/DeleteFlywheelCommand";
import { DeleteResourcePolicyCommand, } from "./commands/DeleteResourcePolicyCommand";
import { DescribeDatasetCommand, } from "./commands/DescribeDatasetCommand";
import { DescribeDocumentClassificationJobCommand, } from "./commands/DescribeDocumentClassificationJobCommand";
import { DescribeDocumentClassifierCommand, } from "./commands/DescribeDocumentClassifierCommand";
import { DescribeDominantLanguageDetectionJobCommand, } from "./commands/DescribeDominantLanguageDetectionJobCommand";
import { DescribeEndpointCommand, } from "./commands/DescribeEndpointCommand";
import { DescribeEntitiesDetectionJobCommand, } from "./commands/DescribeEntitiesDetectionJobCommand";
import { DescribeEntityRecognizerCommand, } from "./commands/DescribeEntityRecognizerCommand";
import { DescribeEventsDetectionJobCommand, } from "./commands/DescribeEventsDetectionJobCommand";
import { DescribeFlywheelCommand, } from "./commands/DescribeFlywheelCommand";
import { DescribeFlywheelIterationCommand, } from "./commands/DescribeFlywheelIterationCommand";
import { DescribeKeyPhrasesDetectionJobCommand, } from "./commands/DescribeKeyPhrasesDetectionJobCommand";
import { DescribePiiEntitiesDetectionJobCommand, } from "./commands/DescribePiiEntitiesDetectionJobCommand";
import { DescribeResourcePolicyCommand, } from "./commands/DescribeResourcePolicyCommand";
import { DescribeSentimentDetectionJobCommand, } from "./commands/DescribeSentimentDetectionJobCommand";
import { DescribeTargetedSentimentDetectionJobCommand, } from "./commands/DescribeTargetedSentimentDetectionJobCommand";
import { DescribeTopicsDetectionJobCommand, } from "./commands/DescribeTopicsDetectionJobCommand";
import { DetectDominantLanguageCommand, } from "./commands/DetectDominantLanguageCommand";
import { DetectEntitiesCommand, } from "./commands/DetectEntitiesCommand";
import { DetectKeyPhrasesCommand, } from "./commands/DetectKeyPhrasesCommand";
import { DetectPiiEntitiesCommand, } from "./commands/DetectPiiEntitiesCommand";
import { DetectSentimentCommand, } from "./commands/DetectSentimentCommand";
import { DetectSyntaxCommand, } from "./commands/DetectSyntaxCommand";
import { DetectTargetedSentimentCommand, } from "./commands/DetectTargetedSentimentCommand";
import { DetectToxicContentCommand, } from "./commands/DetectToxicContentCommand";
import { ImportModelCommand } from "./commands/ImportModelCommand";
import { ListDatasetsCommand, } from "./commands/ListDatasetsCommand";
import { ListDocumentClassificationJobsCommand, } from "./commands/ListDocumentClassificationJobsCommand";
import { ListDocumentClassifiersCommand, } from "./commands/ListDocumentClassifiersCommand";
import { ListDocumentClassifierSummariesCommand, } from "./commands/ListDocumentClassifierSummariesCommand";
import { ListDominantLanguageDetectionJobsCommand, } from "./commands/ListDominantLanguageDetectionJobsCommand";
import { ListEndpointsCommand, } from "./commands/ListEndpointsCommand";
import { ListEntitiesDetectionJobsCommand, } from "./commands/ListEntitiesDetectionJobsCommand";
import { ListEntityRecognizersCommand, } from "./commands/ListEntityRecognizersCommand";
import { ListEntityRecognizerSummariesCommand, } from "./commands/ListEntityRecognizerSummariesCommand";
import { ListEventsDetectionJobsCommand, } from "./commands/ListEventsDetectionJobsCommand";
import { ListFlywheelIterationHistoryCommand, } from "./commands/ListFlywheelIterationHistoryCommand";
import { ListFlywheelsCommand, } from "./commands/ListFlywheelsCommand";
import { ListKeyPhrasesDetectionJobsCommand, } from "./commands/ListKeyPhrasesDetectionJobsCommand";
import { ListPiiEntitiesDetectionJobsCommand, } from "./commands/ListPiiEntitiesDetectionJobsCommand";
import { ListSentimentDetectionJobsCommand, } from "./commands/ListSentimentDetectionJobsCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { ListTargetedSentimentDetectionJobsCommand, } from "./commands/ListTargetedSentimentDetectionJobsCommand";
import { ListTopicsDetectionJobsCommand, } from "./commands/ListTopicsDetectionJobsCommand";
import { PutResourcePolicyCommand, } from "./commands/PutResourcePolicyCommand";
import { StartDocumentClassificationJobCommand, } from "./commands/StartDocumentClassificationJobCommand";
import { StartDominantLanguageDetectionJobCommand, } from "./commands/StartDominantLanguageDetectionJobCommand";
import { StartEntitiesDetectionJobCommand, } from "./commands/StartEntitiesDetectionJobCommand";
import { StartEventsDetectionJobCommand, } from "./commands/StartEventsDetectionJobCommand";
import { StartFlywheelIterationCommand, } from "./commands/StartFlywheelIterationCommand";
import { StartKeyPhrasesDetectionJobCommand, } from "./commands/StartKeyPhrasesDetectionJobCommand";
import { StartPiiEntitiesDetectionJobCommand, } from "./commands/StartPiiEntitiesDetectionJobCommand";
import { StartSentimentDetectionJobCommand, } from "./commands/StartSentimentDetectionJobCommand";
import { StartTargetedSentimentDetectionJobCommand, } from "./commands/StartTargetedSentimentDetectionJobCommand";
import { StartTopicsDetectionJobCommand, } from "./commands/StartTopicsDetectionJobCommand";
import { StopDominantLanguageDetectionJobCommand, } from "./commands/StopDominantLanguageDetectionJobCommand";
import { StopEntitiesDetectionJobCommand, } from "./commands/StopEntitiesDetectionJobCommand";
import { StopEventsDetectionJobCommand, } from "./commands/StopEventsDetectionJobCommand";
import { StopKeyPhrasesDetectionJobCommand, } from "./commands/StopKeyPhrasesDetectionJobCommand";
import { StopPiiEntitiesDetectionJobCommand, } from "./commands/StopPiiEntitiesDetectionJobCommand";
import { StopSentimentDetectionJobCommand, } from "./commands/StopSentimentDetectionJobCommand";
import { StopTargetedSentimentDetectionJobCommand, } from "./commands/StopTargetedSentimentDetectionJobCommand";
import { StopTrainingDocumentClassifierCommand, } from "./commands/StopTrainingDocumentClassifierCommand";
import { StopTrainingEntityRecognizerCommand, } from "./commands/StopTrainingEntityRecognizerCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UpdateEndpointCommand, } from "./commands/UpdateEndpointCommand";
import { UpdateFlywheelCommand, } from "./commands/UpdateFlywheelCommand";
import { ComprehendClient } from "./ComprehendClient";
const commands = {
    BatchDetectDominantLanguageCommand,
    BatchDetectEntitiesCommand,
    BatchDetectKeyPhrasesCommand,
    BatchDetectSentimentCommand,
    BatchDetectSyntaxCommand,
    BatchDetectTargetedSentimentCommand,
    ClassifyDocumentCommand,
    ContainsPiiEntitiesCommand,
    CreateDatasetCommand,
    CreateDocumentClassifierCommand,
    CreateEndpointCommand,
    CreateEntityRecognizerCommand,
    CreateFlywheelCommand,
    DeleteDocumentClassifierCommand,
    DeleteEndpointCommand,
    DeleteEntityRecognizerCommand,
    DeleteFlywheelCommand,
    DeleteResourcePolicyCommand,
    DescribeDatasetCommand,
    DescribeDocumentClassificationJobCommand,
    DescribeDocumentClassifierCommand,
    DescribeDominantLanguageDetectionJobCommand,
    DescribeEndpointCommand,
    DescribeEntitiesDetectionJobCommand,
    DescribeEntityRecognizerCommand,
    DescribeEventsDetectionJobCommand,
    DescribeFlywheelCommand,
    DescribeFlywheelIterationCommand,
    DescribeKeyPhrasesDetectionJobCommand,
    DescribePiiEntitiesDetectionJobCommand,
    DescribeResourcePolicyCommand,
    DescribeSentimentDetectionJobCommand,
    DescribeTargetedSentimentDetectionJobCommand,
    DescribeTopicsDetectionJobCommand,
    DetectDominantLanguageCommand,
    DetectEntitiesCommand,
    DetectKeyPhrasesCommand,
    DetectPiiEntitiesCommand,
    DetectSentimentCommand,
    DetectSyntaxCommand,
    DetectTargetedSentimentCommand,
    DetectToxicContentCommand,
    ImportModelCommand,
    ListDatasetsCommand,
    ListDocumentClassificationJobsCommand,
    ListDocumentClassifiersCommand,
    ListDocumentClassifierSummariesCommand,
    ListDominantLanguageDetectionJobsCommand,
    ListEndpointsCommand,
    ListEntitiesDetectionJobsCommand,
    ListEntityRecognizersCommand,
    ListEntityRecognizerSummariesCommand,
    ListEventsDetectionJobsCommand,
    ListFlywheelIterationHistoryCommand,
    ListFlywheelsCommand,
    ListKeyPhrasesDetectionJobsCommand,
    ListPiiEntitiesDetectionJobsCommand,
    ListSentimentDetectionJobsCommand,
    ListTagsForResourceCommand,
    ListTargetedSentimentDetectionJobsCommand,
    ListTopicsDetectionJobsCommand,
    PutResourcePolicyCommand,
    StartDocumentClassificationJobCommand,
    StartDominantLanguageDetectionJobCommand,
    StartEntitiesDetectionJobCommand,
    StartEventsDetectionJobCommand,
    StartFlywheelIterationCommand,
    StartKeyPhrasesDetectionJobCommand,
    StartPiiEntitiesDetectionJobCommand,
    StartSentimentDetectionJobCommand,
    StartTargetedSentimentDetectionJobCommand,
    StartTopicsDetectionJobCommand,
    StopDominantLanguageDetectionJobCommand,
    StopEntitiesDetectionJobCommand,
    StopEventsDetectionJobCommand,
    StopKeyPhrasesDetectionJobCommand,
    StopPiiEntitiesDetectionJobCommand,
    StopSentimentDetectionJobCommand,
    StopTargetedSentimentDetectionJobCommand,
    StopTrainingDocumentClassifierCommand,
    StopTrainingEntityRecognizerCommand,
    TagResourceCommand,
    UntagResourceCommand,
    UpdateEndpointCommand,
    UpdateFlywheelCommand,
};
export class Comprehend extends ComprehendClient {
}
createAggregatedClient(commands, Comprehend);
